import React from "react";
import CompanyName from "./CompanyName";

const CareersFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="careers-footer">
      <div className="careers-container">
        <div className="careers-footer__inner">
          <p className="careers-footer__copyright">
            © {currentYear} <CompanyName />. All rights reserved.
          </p>

          <nav className="careers-footer__links" aria-label="Footer navigation">
            <a href="/privacy-policy">Privacy Policy</a>

            <a href="/terms-of-service">Terms of Service</a>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default CareersFooter;
